const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/signup.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(unauthenticated)/signup')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});